<template>
  <v-row>
    <v-col>
      <v-select
        :items="items"
        label="Third Party Billing Account"
        item-text="title"
        item-value="id"
        placeholder="Account"
        :disabled="!items?.length"
        v-model="selectValue"
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: "BillingAccount",
  props: {
    items: {
      type: Array
    }
  },
  data() {
    return {
      loading: false,
      search: "",
      rules: {
        required: [v => !!v || "Please apply a valid account"]
      },
      billingMessage: ""
    };
  },
  computed: {
    ...mapFields("clients", [
      "items[0].third_party_billing",
      "items[0].clients_third_party_billing"
    ]),
    ...mapGetters("clients", ["selectedClient"]),
    billingAccount() {
      if (this.clients_third_party_billing) {
        return (
          this.clients_third_party_billing.billing_only_account_number || ""
        );
      }
      return "";
    },
    hasBillingAccount() {
      return (
        this.clients_third_party_billing &&
        this.clients_third_party_billing.billing_only_account_number
      );
    },
    selectValue() {
      return this.items && this.items?.length ? this.items[0] : null;
    }
  },
  methods: {
    ...mapActions("clients", ["getBillingOnlyClientId", "initClientAddresses"]),
    ...mapMutations("clients", ["addThirdPartyBilling", "removeAddress"]),
    resetBillingAccount() {
      this.addThirdPartyBilling(false);
    },
    verifyBillingAccount() {
      this.billingMessage = "";
      this.loading = true;

      this.getBillingOnlyClientId(this.search).then(result => {
        this.search = ""; // Clear search field
        this.loading = false;
        if (!result) {
          this.billingMessage = "Billing account could not be located";
        }
      });
    }
  },
  watch: {
    selectedClient(newVal) {
      this.third_party_billing = newVal.third_party_billing;
    }
  }
};
</script>

<style>
.selectedBilling .v-text-field__details * {
  color: red !important;
}
</style>
